import { router } from '@inertiajs/react';
import { Loader2, Search } from 'lucide-react';
import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { useDebouncedCallback } from '@/hooks/use-debounced-callback';

export function EmailsSearch({ search }: { search: string | null }) {
  const [isSearching, setIsSearching] = useState(false);

  const handleSearch = useDebouncedCallback((term: string) => {
    // Searching always goes back to the first page.
    router.get(
      '/emails',
      term ? { search: term } : {},
      {
        replace: true,
        preserveState: true,
        preserveScroll: true,
        onStart: () => setIsSearching(true),
        onFinish: () => setIsSearching(false),
      },
    );
  }, 300);

  return (
    <div className="relative">
      <Search className="-translate-y-1/2 absolute top-1/2 left-3 h-4 w-4 text-muted-foreground" />
      {isSearching && (
        <Loader2 className="-translate-y-1/2 absolute top-1/2 right-3 h-4 w-4 animate-spin text-muted-foreground" />
      )}
      <Input
        placeholder="Search emails..."
        className="pr-10 pl-10"
        defaultValue={search ?? ''}
        onChange={(e) => handleSearch(e.target.value)}
      />
    </div>
  );
}
